import { render, staticRenderFns } from "./ColumnPanel.vue?vue&type=template&id=112f0732&scoped=true&"
import script from "./ColumnPanel.vue?vue&type=script&lang=js&"
export * from "./ColumnPanel.vue?vue&type=script&lang=js&"
import style0 from "./ColumnPanel.vue?vue&type=style&index=0&id=112f0732&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112f0732",
  null
  
)

export default component.exports